"use strict";

import { c as _c } from "react/compiler-runtime";
import { RelayEnvironmentProvider, useRelayEnvironment as useRelayEnvironmentImported } from 'react-relay/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export { createEnvironment, getEnvironment, initPersistedEnvironment } from './base-environment';
export { createEnvironmentWithSubscription } from './subscription-environment';
export { GraphError } from './GraphError';
export { createGraphError } from './utils';
export const EnvironmentProvider = ({
  children,
  environment
}) => /*#__PURE__*/_jsx(RelayEnvironmentProvider, {
  environment: environment,
  children: children
});
export const useRelayEnvironment = () => {
  const $ = _c(1);
  if ($[0] !== "37ec64398b83e60fffec94fb03f3754a2f35d709446ffbd398f580cce558b672") {
    for (let $i = 0; $i < 1; $i += 1) {
      $[$i] = Symbol.for("react.memo_cache_sentinel");
    }
    $[0] = "37ec64398b83e60fffec94fb03f3754a2f35d709446ffbd398f580cce558b672";
  }
  return useRelayEnvironmentImported();
};